/**
 * Feature switch keys
 *
 * Defines all available feature switch identifiers.
 */
export enum FeatureSwitchKey {
  Dummy = "dummy",
  AhrefsConnector = "ahrefsConnector",
  BillConnector = "billConnector",
  BentomlConnector = "bentomlConnector",
  BoxConnector = "boxConnector",
  CanvaConnector = "canvaConnector",
  CalComConnector = "calComConnector",
  CopperConnector = "copperConnector",
  DatadogConnector = "datadogConnector",
  DeelConnector = "deelConnector",
  DocuSignConnector = "docusignConnector",
  DropboxConnector = "dropboxConnector",
  FigmaConnector = "figmaConnector",
  ExpensifyConnector = "expensifyConnector",
  GoogleContactsConnector = "googleContactsConnector",
  GoogleFormsConnector = "googleFormsConnector",
  JoggAiConnector = "joggAiConnector",
  JoggAiBuiltIn = "joggAiBuiltIn",
  MercuryConnector = "mercuryConnector",
  NeonConnector = "neonConnector",
  NetSuiteConnector = "netSuiteConnector",
  GarminConnectConnector = "garminConnectConnector",
  QuickBooksConnector = "quickbooksConnector",
  RedditConnector = "redditConnector",
  SupabaseConnector = "supabaseConnector",
  WebflowConnector = "webflowConnector",
  CloseConnector = "closeConnector",
  MetaAdsConnector = "metaAdsConnector",
  TikTokAdsConnector = "tiktokAdsConnector",
  AwsConnector = "awsConnector",
  PosthogConnector = "posthogConnector",
  PayPalConnector = "payPalConnector",
  RampConnector = "rampConnector",
  MailchimpConnector = "mailchimpConnector",
  ResendConnector = "resendConnector",
  PexelsConnector = "pexelsConnector",
  SpotifyConnector = "spotifyConnector",
  ZeroDebug = "zeroDebug",
  ZeroBrowser = "zeroBrowser",
  RustZeroCli = "rustZeroCli",
  R2ZeroCli = "r2ZeroCli",
  Banking = "banking",
  Lab = "lab",
  NotionWorkflowAutomations = "notionWorkflowAutomations",
  GithubWebhookAutomations = "githubWebhookAutomations",
  MorningBrief = "morningBrief",
  ManualMorningBrief = "manualMorningBrief",
  TestOauthConnector = "testOauthConnector",
  FreshdeskConnector = "freshdeskConnector",
  StabilityAiConnector = "stabilityAiConnector",
  ZoomConnector = "zoomConnector",
  WorkdayConnector = "workdayConnector",
  CodexFastMode = "codexFastMode",
  RealAgentInPreview = "realAgentInPreview",
  ComposerUploadPopover = "composerUploadPopover",
  StructuredPromptInlineTemplates = "structuredPromptInlineTemplates",
  CustomModelGateways = "customModelGateways",

  ZapierConnector = "zapierConnector",
  ComputerUseDesktopPlugins = "computerUseDesktopPlugins",
  ChatThreadUnifiedSearch = "chatThreadUnifiedSearch",
  ChatErrorRecovery = "chatErrorRecovery",
  ChatSteer = "chatSteer",
  PwaChatKeyboardGestures = "pwaChatKeyboardGestures",
  SidebarSubscriptionUsage = "sidebarSubscriptionUsage",
  TeamsIntegration = "teamsIntegration",
  FeishuIntegration = "feishuIntegration",
  StrapiIntegration = "strapiIntegration",
  ArtifactKeyV2 = "artifactKeyV2",
  HostedArtifactVersions = "hostedArtifactVersions",
  WorkflowConnectorReadiness = "workflowConnectorReadiness",
  ComposerConnectorPermissions = "composerConnectorPermissions",
  ThreeColumnNav = "threeColumnNav",
  ChatThreadSidebarAutoOpen = "chatThreadSidebarAutoOpen",
  ArtifactSidebarInlineOpen = "artifactSidebarInlineOpen",
  CustomConnectorCliCreate = "customConnectorCliCreate",
  CustomConnectorOAuth2 = "customConnectorOAuth2",
  MermaidDiagrams = "mermaidDiagrams",
  CustomConnectorPermissions = "customConnectorPermissions",
}
